import { combineReducers } from 'redux'
// import locationReducer from './location'
import { sessionReducer } from 'utils/sessionService'
import { responsiveStateReducer as browser } from 'redux-responsive'
import auth from 'store/modules/auth'
import networks from 'store/modules/networks'
import routes from 'store/modules/routes'
import site from 'store/modules/site'
import email from 'store/modules/email'
import networkreports from 'store/modules/networkreports'
import ltareports from 'store/modules/ltareport'
import assets from 'store/modules/assets'
import works from 'store/modules/works'
import accounts from 'store/modules/accounts'
import constructiononnetwork from 'store/modules/constructiononnetwork'
import sitesreports from 'store/modules/sitesreports'
import siteAudit from 'routes/SiteAudit/modules/siteAudit'
import dashboard from 'routes/Dashboard/modules/dashboard'
import manholes from 'routes/Manholes/modules/manholes'
import plannedworks from 'routes/PlannedWorks/modules/plannedworks'
import spares from 'routes/Spares/modules/spares'
import utilityrequests from 'routes/UtilityRequests/modules/utilityrequests'
import documents from 'routes/DocumentManagement/modules/documents'
import appVersions from 'routes/AppDownload/modules/appVersions'
import ncereports from 'routes/NceReports/modules/ncereports'

export const makeRootReducer = (asyncReducers) => {
  // Add async reducers here
  return combineReducers({
    // location: locationReducer,
    session: sessionReducer,
    browser,
    auth,
    site,
    networks,
    email,
    routes,
    networkreports,
    ltareports,
    assets,
    works,
    accounts,
    constructiononnetwork,
    sitesreports,
    siteAudit,
    dashboard,
    manholes,
    plannedworks,
    spares,
    utilityrequests,
    documents,
    appVersions,
    ncereports,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
